<template>
  <div class="print-tag-batches">
    <transition
      name="fade"
      mode="out-in"
    >
      <div class="print-tag-batches__card-container">
        <div
          v-for="(batchUnprinted, index) in batchesUnprinted"
          :key="'batchesUnprinted' + index"
          :md-item="batchesUnprinted"
          class="card-box"
          :class="{ 'collapsed': batchUnprinted.expanded }"
        >
          <batch-card
            :index="index"
            :batch="batchUnprinted"
          />
        </div>

        <div
          v-if="batchesPrinted && batchesPrinted.length > 0"
          :class="{
            'subsection-container-alternative': hasBatchesPrinted && !hasBatchesUnprinted
          }"
          class="subsection-container"
        >
          <h2>Impressos</h2>
          <hr>
        </div>

        <div
          v-for="(batchPrinted, index) in batchesPrinted"
          :key="'batchesPrinted' + index"
          :md-item="batchesUnprinted"
          class="card-box-printed"
        >
          <batch-card
            :index="index"
            :batch="batchPrinted"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import mixin from './BatchesMixin'
import BatchCard from './Cards/BatchCard'
import { mapGetters } from 'vuex'

export default {
  name: 'BatchesGrid',
  components: {
    'batch-card': BatchCard
  },
  mixins: [mixin],
  computed: {
    ...mapGetters(['batchesUnprinted']),
    ...mapGetters(['batchesPrinted'])
  }
}
</script>
